import { fileUrl } from "@/lib/jobOptions";
import { FileText } from "lucide-react";

export default function JobAttachments({ bijlagen }) {
  if (!bijlagen || bijlagen.length === 0) return null;
  const images = bijlagen.filter((b) => (b.content_type || "").startsWith("image/"));
  const others = bijlagen.filter((b) => !(b.content_type || "").startsWith("image/"));

  return (
    <div className="mb-4 space-y-2" data-testid="job-attachments">
      {images.length > 0 && (
        <div className="flex flex-wrap gap-2">
          {images.map((b) => (
            <a key={b.id} href={fileUrl(b.id)} target="_blank" rel="noopener noreferrer"
              data-testid="bijlage-thumb" title={b.naam}
              className="block w-16 h-16 rounded-sm overflow-hidden border border-slate-200 hover:border-orange-400 transition-colors bg-slate-50">
              <img src={fileUrl(b.id)} alt={b.naam} loading="lazy" className="w-full h-full object-cover" />
            </a>
          ))}
        </div>
      )}
      {others.length > 0 && (
        <div className="flex flex-wrap gap-2">
          {others.map((b) => (
            <a key={b.id} href={fileUrl(b.id)} target="_blank" rel="noopener noreferrer"
              data-testid="bijlage-link"
              className="inline-flex items-center gap-1 text-xs text-slate-600 hover:text-orange-600 bg-slate-50 border border-slate-200 rounded-sm px-2 py-1 max-w-full">
              <FileText className="w-3.5 h-3.5 flex-shrink-0" /> <span className="truncate">{b.naam}</span>
            </a>
          ))}
        </div>
      )}
    </div>
  );
}
